import { LTR, SUPPORTED_LANGUAGES } from 'arbitrip-common/translation/const';
import AboutComponent from './AboutComponent.react.js';
import { useTranslation } from 'react-i18next';
import { useState, useMemo } from 'react';
import TranslationToggleNotice from '@/components/general/TranslationToggleNotice.jsx';

const AboutTab = ({ hotelName, base, translations, durationMs }) => {
	const { i18n, t } = useTranslation();
	const lang = i18n?.language;
	const translated = lang && lang !== SUPPORTED_LANGUAGES.EN ? translations?.[lang] : null;
	const translatedExists = !!translated;
	const [showOriginal, setShowOriginal] = useState(false);
	const dirForContent = useMemo(() => (showOriginal ? LTR : i18n.dir()), [showOriginal, i18n]);
	const selectedAbout = showOriginal ? base : translated || base;

	return (
		<div className="about-container">
			<TranslationToggleNotice
				translatedExists={translatedExists}
				showOriginal={showOriginal}
				onToggle={() => setShowOriginal((v) => !v)}
				durationMs={durationMs}
			/>
			<div dir={dirForContent}>
				<AboutComponent hotel_name={hotelName} description={selectedAbout} forceOriginalTitles={showOriginal} />
			</div>
		</div>
	);
};

export default AboutTab;
